import { render, staticRenderFns } from "./RegisterSection.vue?vue&type=template&id=1e1e66aa&scoped=true"
import script from "./RegisterSection.vue?vue&type=script&lang=js"
export * from "./RegisterSection.vue?vue&type=script&lang=js"
import style0 from "./RegisterSection.vue?vue&type=style&index=0&id=1e1e66aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1e66aa",
  null
  
)

export default component.exports